<template>

  <nx-dialog :value="active" @input="close" max-width="400px" icon="drive_file_rename_outline"
               :title="$t('message.bag.actions.rename')">
      <v-text-field autofocus :label="$t('message.bag.renameText')" v-model="renameText" @keyup.enter="handleRename"/>
      <template slot="actions">
        <v-btn color="secondary"
               flat
               @click="close"
               :disabled="loading"
        >{{ $t('message.common.close') }}
        </v-btn>
        <v-btn color="secondary"
               flat
               :loading="loading"
               :disabled="!this.renameText"
               @click="handleRename"
        >{{ $t('message.common.accept') }}
        </v-btn>
      </template>
    </nx-dialog>

</template>

<script>
import { mapActions } from 'vuex';
import NxDialog from '@/components/dialogs/Dialog';

export default {
  name: 'nx-bag-rename-action',
  components: {
    NxDialog,
  },
  props: {
    active: Boolean,
    item: Object,
  },
  data() {
    return {
      renameText: null,
      loading: false,
    };
  },
  methods: {
    ...mapActions('bag/clipboard', { rename: 'RENAME' }),
    close() {
      this.renameText = null;
      this.loading = false;
      this.$emit('close');
    },
    async handleRename() {
      if (!this.renameText) return;
      this.loading = true;
      try {
        await this.rename({
          item: this.item,
          title: this.renameText,
        });
      } catch (e) {
        console.error(e);
        this.toast.notify('message.error.serverError');
      } finally {
        this.close();
      }
    },
  },
};
</script>
